import { React } from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        &copy; Jake Wilson
        
      </div>
    </footer>
  );
};

export default Footer;
